import FilterBar from "../../components/FilterBar";
import { Grid, TextField, Typography } from "@mui/material";
import { CustomerRmaFilter } from "./customerRmaTypes";
import { filterConstraintChecker } from "./customerRmaUtils";

interface Props {
  filters: CustomerRmaFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: CustomerRmaFilter;
}

const RmaFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={filterConstraintChecker}
        constraintMessage="Shipped From date must be before Shipped To date."
        children={(handler: (event: any) => void) => [
          <TextField
            name="nameId"
            label="Filter By RMA ID"
            variant="outlined"
            value={filters.nameId}
            onChange={handler}
          />,
          <TextField
            name="serial"
            label="Filter By Serial"
            variant="outlined"
            value={filters.serial}
            onChange={handler}
          />,
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item>
              <Typography>Shipped From:</Typography>
            </Grid>
            <Grid item>
              <TextField
                name="shipDateFrom"
                variant="outlined"
                type="date"
                style={{ width: 175 }}
                value={filters.shipDateFrom}
                onChange={handler}
              />
            </Grid>
            <Grid item>
              <Typography>To:</Typography>
            </Grid>
            <Grid item>
              <TextField
                name="shipDateTo"
                variant="outlined"
                type="date"
                style={{ width: 175 }}
                value={filters.shipDateTo}
                onChange={handler}
              />
            </Grid>
          </Grid>,
        ]}
      />
    </>
  );
};

export default RmaFilterBar;
